import React from 'react'

const Plug = ({className}) => (

<svg width="20px" height="20px" viewBox="0 0 463.264 463.264" className={className}>
<g>
	<path d="M395.42,82.072c-43.749-43.749-101.917-67.843-163.788-67.843S111.593,38.323,67.844,82.072
		C24.094,125.822,0,183.989,0,245.861c0,41.319,11.02,81.888,31.868,117.317c20.225,34.369,49.143,63.117,83.629,83.137
		c3.174,1.842,6.642,2.719,10.066,2.719c6.925,0,13.664-3.586,17.391-10.008c5.569-9.592,2.307-21.885-7.288-27.455
		C76.764,377.38,40.173,313.884,40.173,245.86c0-105.57,85.888-191.458,191.458-191.458c105.571,0,191.458,85.888,191.458,191.458
		c0,44.625-12.084,81.852-34.948,107.654c-18.607,21.002-43.59,33.047-68.539,33.047c-25.002,0-53.332-13.154-63.748-47.994
		c40.298-8.321,70.687-44.084,70.687-86.809v-58.534c0-2.772-2.249-5.021-5.021-5.021h-26.867v-54.801
		c0-11.093-8.992-20.086-20.085-20.086c-11.095,0-20.088,8.993-20.088,20.086v54.801h-45.693v-54.801
		c0-11.093-8.993-20.086-20.087-20.086c-11.094,0-20.086,8.993-20.086,20.086v54.801h-26.868c-2.773,0-5.021,2.249-5.021,5.021
		v58.534c0,45.289,34.144,82.748,78.04,88.002c4.717,22.156,14.561,41.205,29.139,56.072c19.541,19.926,46.427,30.9,75.701,30.9
		c36.438,0,72.379-16.977,98.607-46.578c20.553-23.195,45.053-65.324,45.053-134.296C463.263,183.989,439.17,125.821,395.42,82.072z
		"/>
</g>
</svg>
)

export default Plug